import { render, staticRenderFns } from "./TagsScrollPane.vue?vue&type=template&id=33c5cd92&scoped=true"
import script from "./TagsScrollPane.vue?vue&type=script&lang=ts"
export * from "./TagsScrollPane.vue?vue&type=script&lang=ts"
import style0 from "./TagsScrollPane.vue?vue&type=style&index=0&id=33c5cd92&prod&lang=scss"
import style1 from "./TagsScrollPane.vue?vue&type=style&index=1&id=33c5cd92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33c5cd92",
  null
  
)

export default component.exports